import { createBrowserRouter, Navigate } from "react-router";
import { Layout } from "components/UI";
import {
  AddRole,
  Apps,
  CreateApp,
  Billings,
  BillingUpgrade,
  BillingAddon,
  BusinessFlow,
  Channels,
  InhouseChannelDetail,
  ChatBot,
  ChatBotFlow,
  Company,
  ConversationIndex,
  Conversations,
  DetailApp,
  EditRole,
  Forgot,
  Invite,
  ListCompanies,
  Login,
  MainPage,
  Page404,
  BillingPaymentSuccess,
  Profile,
  ResetPassword,
  Roles,
  SelectCompany,
  Settings,
  Templates,
  Users,
  Tags,
  Categories,
  ContactPage,
  DetailContactPage,
  ImportContactPage,
  BlastPage,
  DetailBlastPage,
  CreateBlastPage,
  Divisions,
  LeadAndTaskManagement,
  // EditContactPage,
  Reports,
  ChatLinesCount,
  OnlineDuration,
  TeamResponseTime,
  IndividualResponseTime,
  AutoTransferConversation,
  DetailResponseTime,
  ListOfUserRating,
  StatisticUserRating,
  MeetingManagement,
  MeetingSchedule,
  Audit,
  Help,
  HelpDetail,
  FaqUser,
  SettingsQualityAssurance,
  QualityAssurance,
  DataQualityAssuranceReportsPage,
  StatisticQualityAssuranceReportsPage,
  AgentNumCharStatistics,
  DailyTeamChatStatistics,
  VolumeIncoming,
  WebhookPage,
  DetailAutoTransferConversation,
  TicketingPage,
  CreateTicketPage,
  DetailTicketPage,
  InboxTicketingPage,
  CrmIsoSettingPage, // [crm-iso]
} from "./pages";
import ErrorPage from "pages/ErrorPage";
import ConversationsList from "components/apps/conversations";
import CreateChat from "components/apps/conversations/createChat";
import ConversationsFilter from "components/apps/conversations/filterChat";
import UserRatingPublic from "pages/public/userRating";
import NotFoundPublic from "pages/public/notFound";
import PublicPage from "pages/public/PublicPage";
import AppConnectPublic from "pages/public/appConnect";

export const generateRoutes = () => {
  const PublicRoutes = [
    {
      path: "/p/",
      errorElement: <ErrorPage />,
      children: [
        {
          index: true,
          element: <PublicPage />,
          errorElement: <ErrorPage />,
        },
        {
          path: "user-rating",
          element: <UserRatingPublic />,
          errorElement: <ErrorPage />,
        },
        {
          path: "app-connect",
          element: <AppConnectPublic />,
          errorElement: <ErrorPage />,
        },
        {
          path: "404",
          element: <NotFoundPublic />,
          errorElement: <ErrorPage />,
        },
        {
          path: "*",
          element: <Navigate to={`/p/404`} replace />,
          errorElement: <ErrorPage />,
        },
      ],
    },
  ];
  return createBrowserRouter([
    {
      path: "/",
      element: <Layout />,
      errorElement: <ErrorPage />,
      children: [
        {
          path: "/",
          element: <MainPage />,
        },
        {
          path: "/conversations/:id",
          element: <Conversations />,
          errorElement: <ErrorPage />,
          children: [
            {
              index: true,
              element: <ConversationIndex />,
            },
            {
              path: "/conversations/:id/list",
              element: <ConversationsList />,
              errorElement: <ErrorPage />,
            },
            {
              path: "/conversations/:id/search",
              element: <ConversationsFilter />,
              errorElement: <ErrorPage />,
            },
            {
              path: "/conversations/:id/create",
              element: <CreateChat />,
              errorElement: <ErrorPage />,
            },
          ],
        },
        ...PublicRoutes,
        {
          path: "/settings",
          element: <Settings />,
          errorElement: <ErrorPage />,
        },
        {
          path: "/settings/company",
          element: <Company />,
          errorElement: <ErrorPage />,
          handle: {
            permission: "setting_company",
          },
        },

        {
          path: "/settings/billing",
          element: <Billings />,
          errorElement: <ErrorPage />,
          handle: {
            permission: "setting_billing",
          },
        },
        {
          path: "/settings/billing/upgrade",
          element: <BillingUpgrade />,
          errorElement: <ErrorPage />,
          handle: {
            permission: "setting_billing",
          },
        },
        {
          path: "/settings/billing/addon",
          element: <BillingAddon />,
          errorElement: <ErrorPage />,
          handle: {
            permission: "setting_billing",
          },
        },
        {
          path: "/settings/template",
          element: <Templates />,
          errorElement: <ErrorPage />,
          handle: {
            permission: "setting_template",
          },
        },
        {
          path: "/settings/businessflow",
          element: <BusinessFlow />,
          errorElement: <ErrorPage />,
          handle: {
            permission: "setting_business_flow",
          },
        },
        {
          path: "/user/login",
          element: <Login />,
          errorElement: <ErrorPage />,
        },
        {
          path: "/user/forgot",
          element: <Forgot />,
          errorElement: <ErrorPage />,
        },
        {
          path: "/user/reset-password/:token",
          element: <ResetPassword />,
          errorElement: <ErrorPage />,
        },
        {
          path: "/user/invite/:token",
          element: <Invite />,
          errorElement: <ErrorPage />,
        },
        {
          path: "/user/select-company",
          element: <SelectCompany />,
          errorElement: <ErrorPage />,
        },
        {
          path: "/user/billing/success",
          element: <BillingPaymentSuccess />,
          errorElement: <ErrorPage />,
        },
        {
          path: "/companies",
          element: <ListCompanies />,
          errorElement: <ErrorPage />,
        },

        {
          path: "/settings/profile",
          element: <Profile />,
          errorElement: <ErrorPage />,
          handle: {
            permission: "setting_profile",
          },
        },
        {
          path: "/settings/users",
          element: <Users />,
          errorElement: <ErrorPage />,
          handle: {
            permission: "setting_users",
          },
        },
        {
          path: "/settings/roles",
          element: <Roles />,
          errorElement: <ErrorPage />,
          handle: {
            permission: "setting_roles",
          },
        },
        {
          path: "/settings/roles/add",
          element: <AddRole />,
          errorElement: <ErrorPage />,
          handle: {
            permission: "setting_roles_add",
          },
        },
        {
          path: "/settings/roles/edit/:id",
          element: <EditRole />,
          errorElement: <ErrorPage />,
          handle: {
            permission: "setting_roles_edit",
          },
        },
        {
          path: "/settings/tags",
          element: <Tags />,
          errorElement: <ErrorPage />,
          handle: {
            permission: "setting_tags",
          },
        },
        {
          path: "/settings/channels",
          element: <Channels />,
          errorElement: <ErrorPage />,
          handle: {
            permission: "setting_channel",
          },
        },
        {
          path: "/settings/channels/inhouse/:id",
          element: <InhouseChannelDetail />,
          errorElement: <ErrorPage />,
          handle: {
            permission: "setting_channel",
          },
        },
        {
          path: "/settings/apps",
          element: <Apps />,
          errorElement: <ErrorPage />,
          handle: {
            permission: "setting_apikeys",
          },
        },
        {
          path: "/settings/apps/create",
          element: <CreateApp />,
          errorElement: <ErrorPage />,
          handle: {
            permission: "setting_apikeys",
          },
        },
        {
          path: "/settings/apps/detail/:id",
          element: <DetailApp />,
          errorElement: <ErrorPage />,
          handle: {
            permission: "setting_apikeys",
          },
        },
        {
          path: "/settings/categories",
          element: <Categories />,
          errorElement: <ErrorPage />,
          handle: {
            permission: "setting_category",
          },
        },
        {
          path: "/settings/bots",
          element: <ChatBot />,
          errorElement: <ErrorPage />,
          handle: {
            permission: "setting_chatbots",
          },
        },
        {
          path: "/settings/bots/detail/:id",
          element: <ChatBotFlow />,
          errorElement: <ErrorPage />,
          handle: {
            permission: "setting_chatbots",
          },
        },
        {
          path: "/settings/divisions",
          element: <Divisions />,
          errorElement: <ErrorPage />,
        },
        {
          path: "/contacts",
          element: <ContactPage />,
          errorElement: <ErrorPage />,
          handle: {
            permission: "contacts",
          },
        },
        {
          path: "/contacts/import",
          element: <ImportContactPage />,
          errorElement: <ErrorPage />,
          handle: {
            permission: "contacts",
          },
        },
        {
          path: "/contacts/detail/:id",
          element: <DetailContactPage />,
          errorElement: <ErrorPage />,
          handle: {
            permission: "contacts",
          },
        },
        {
          path: "/lead-and-task-management",
          element: <LeadAndTaskManagement />,
          errorElement: <ErrorPage />,
          handle: {
            permission: "tasks",
          },
        },
        {
          path: "/blast-message",
          element: <BlastPage />,
          errorElement: <ErrorPage />,
          handle: {
            permission: "wa_blast_list",
          },
        },
        {
          path: "/blast-message/create",
          element: <CreateBlastPage />,
          errorElement: <ErrorPage />,
          handle: {
            permission: "wa_blast_add",
          },
        },
        {
          path: "/blast-message/detail/:id",
          element: <DetailBlastPage />,
          errorElement: <ErrorPage />,
          handle: {
            permission: "wa_blast_list",
          },
        },
        {
          path: "/reports",
          element: <Reports />,
          errorElement: <ErrorPage />,
          handle: {
            permission: "reports",
          },
        },
        {
          path: "/reports/chat-lines-count",
          element: <ChatLinesCount />,
          errorElement: <ErrorPage />,
          handle: {
            permission: "reports",
          },
        },
        {
          path: "/reports/online-duration",
          element: <OnlineDuration />,
          errorElement: <ErrorPage />,
          handle: {
            permission: "reports",
          },
        },
        {
          path: "/reports/team-response-time",
          element: <TeamResponseTime />,
          errorElement: <ErrorPage />,
          handle: {
            permission: "reports",
          },
        },
        {
          path: "/reports/individual-response-time",
          element: <IndividualResponseTime />,
          errorElement: <ErrorPage />,
          handle: {
            permission: "reports",
          },
        },
        {
          path: "/reports/auto-transfer-conversation",
          element: <AutoTransferConversation />,
          errorElement: <ErrorPage />,
          handle: {
            permission: "reports",
          },
        },
        {
          path: "/reports/individual-response-time/detail",
          element: <DetailResponseTime />,
          errorElement: <ErrorPage />,
          handle: {
            permission: "reports",
          },
        },
        {
          path: "/reports/auto-transfer-conversation/detail",
          element: <DetailAutoTransferConversation />,
          errorElement: <ErrorPage />,
          handle: {
            permission: "reports",
          },
        },
        {
          path: "/help",
          element: <Help />,
          errorElement: <ErrorPage />,
        },
        {
          path: "/help/detail/:id",
          element: <HelpDetail />,
          errorElement: <ErrorPage />,
        },
        {
          path: "/faqs",
          element: <FaqUser />,
          errorElement: <ErrorPage />,
        },
        {
          path: "/settings/meeting-schedule",
          element: <MeetingManagement />,
          errorElement: <ErrorPage />,
          handle: {
            permission: "setting_meeting_schedule",
          },
        },
        {
          path: "/meeting-management",
          element: <MeetingSchedule />,
          errorElement: <ErrorPage />,
          handle: {
            permission: "meeting_schedule",
          },
        },
        {
          path: "/settings/audit",
          element: <Audit />,
          errorElement: <ErrorPage />,
          handle: {
            permission: "setting_audit",
          },
        },
        {
          path: "/reports/list-of-user-ratings",
          element: <ListOfUserRating />,
          errorElement: <ErrorPage />,
          handle: {
            permission: "reports",
          },
        },
        {
          path: "/reports/statistics-user-ratings",
          element: <StatisticUserRating />,
          errorElement: <ErrorPage />,
          handle: {
            permission: "reports",
          },
        },
        {
          path: "/settings/quality-assurance",
          element: <SettingsQualityAssurance />,
          errorElement: <ErrorPage />,
        },
        {
          path: "/quality-assurance-menu",
          element: <QualityAssurance />,
          errorElement: <ErrorPage />,
        },
        {
          path: "/reports/data-quality-assurance",
          element: <DataQualityAssuranceReportsPage />,
          errorElement: <ErrorPage />,
        },
        {
          path: "/reports/statistics-quality-assurance",
          element: <StatisticQualityAssuranceReportsPage />,
          errorElement: <ErrorPage />,
        },
        {
          path: "/reports/chat-volume-statistics",
          element: <AgentNumCharStatistics />,
          errorElement: <ErrorPage />,
          handle: {
            permission: "reports",
          },
        },
        {
          path: "/reports/chat-volume-statistics-daily",
          element: <DailyTeamChatStatistics />,
          errorElement: <ErrorPage />,
          handle: {
            permission: "reports",
          },
        },
        {
          path: "/reports/volume-incoming",
          element: <VolumeIncoming />,
          errorElement: <ErrorPage />,
          handle: {
            permission: "reports",
          },
        },
        {
          path: "/settings/webhook",
          element: <WebhookPage />,
          errorElement: <ErrorPage />,
          handle: {
            permission: "webhook_manage",
          },
        },
        {
          path: "/ticketing/:id/filter/:slug",
          element: <TicketingPage />,
          errorElement: <ErrorPage />,
        },
        {
          path: "/ticketing/:id",
          element: <TicketingPage />,
          errorElement: <ErrorPage />,
        },
        {
          path: "/ticketing/:id/create",
          element: <CreateTicketPage />,
          errorElement: <ErrorPage />,
        },
        {
          path: "/ticketing/:id/detail/:inbox_ticket_id",
          element: <DetailTicketPage />,
          errorElement: <ErrorPage />,
        },
        {
          path: "/settings/inbox-ticketing",
          element: <InboxTicketingPage />,
          errorElement: <ErrorPage />,
        },
        // [crm-iso] START — hidden feature (lihat CrmIsoSetting/TEARDOWN.md)
        {
          // Hidden feature — hanya bisa diakses via URL (tidak ada menu sidebar)
          path: "/settings/crm-iso-setting",
          element: <CrmIsoSettingPage />,
          errorElement: <ErrorPage />,
        },
        // [crm-iso] END
        {
          path: "*",
          element: <Page404 />,
        },
      ],
    },
  ]);
};
